var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBonusCoins = function SvgBonusCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25 34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bonus-coins_svg__b",
    d: "M0 0h9v9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bonus-coins_svg__d",
    d: "M0 0h7.14v7.914H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bonus-coins_svg__g",
    d: "M0 0h12.747v12.626H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bonus-coins_svg__i",
    d: "M0 0h10.113v11.102H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bonus-coins_svg__l",
    d: "M0 0h20.236v20.045H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bonus-coins_svg__n",
    d: "M0 0h16.054v17.625H0z"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-88.9%",
    y: "-88.9%",
    width: "288.9%",
    height: "277.8%",
    filterUnits: "objectBoundingBox",
    id: "bonus-coins_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.514713232 0 0 0 0 0.389864515 0 0 0 0 0.0153183627 0 0 0 0.5 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-62.8%",
    y: "-63.4%",
    width: "235.4%",
    height: "229.7%",
    filterUnits: "objectBoundingBox",
    id: "bonus-coins_svg__f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.514713232 0 0 0 0 0.389864515 0 0 0 0 0.0153183627 0 0 0 0.5 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-38.1%",
    y: "-38.1%",
    width: "181%",
    height: "176.2%",
    filterUnits: "objectBoundingBox",
    id: "bonus-coins_svg__k"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.514713232 0 0 0 0 0.389864515 0 0 0 0 0.0153183627 0 0 0 0.5 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#bonus-coins_svg__a)",
    transform: "rotate(180 10.367 4.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coins_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coins_svg__b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C6.979 9 9 6.979 9 4.5 9 2.022 6.979 0 4.5 0S0 2.022 0 4.5C0 6.979 2.021 9 4.5 9",
    fill: "#F5BE14",
    mask: "url(#bonus-coins_svg__c)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.86)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coins_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coins_svg__d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.64 0a4.5 4.5 0 0 1 2.932 7.914A15.906 15.906 0 0 1 0 .856 4.48 4.48 0 0 1 2.64 0",
    fill: "#FAD755",
    mask: "url(#bonus-coins_svg__e)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.401a3.099 3.099 0 1 1 0 6.198 3.099 3.099 0 0 1 0-6.198",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.599a3.099 3.099 0 0 1-1.962-5.498 3.099 3.099 0 0 0 2.179 5.303 3.086 3.086 0 0 0 1.962-.7c-.56.553-1.33.895-2.18.895",
    fill: "#FFFF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.401a3.099 3.099 0 0 1 1.651 5.722C9.158 4.153 5.79.008 2.306 2.312A3.09 3.09 0 0 1 4.5 1.4",
    fill: "#D2A00A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.032a2.468 2.468 0 1 1 0 4.935 2.468 2.468 0 0 1 0-4.935",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.032a2.468 2.468 0 0 1 1.258 4.591 13.191 13.191 0 0 1-2.993-3.877A2.46 2.46 0 0 1 4.5 2.032",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.793 5.413a2.467 2.467 0 0 1-.395.664 13.192 13.192 0 0 1-2.946-3.812 2.448 2.448 0 0 1 .698-.208 13.194 13.194 0 0 0 2.644 3.356",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99 6.917A1.217 1.217 0 0 1 2.774 5.7c0 .672-.545 1.216-1.216 1.216.671 0 1.216.545 1.216 1.217 0-.672.545-1.216 1.216-1.216",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bonus-coins_svg__f)",
    transform: "rotate(65 5.252 9.815)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coins_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coins_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.373 12.626c3.51 0 6.374-2.836 6.374-6.313S9.884 0 6.373 0C2.863 0 0 2.836 0 6.313s2.863 6.313 6.373 6.313",
    fill: "#F5BE14",
    mask: "url(#bonus-coins_svg__h)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coins_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coins_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.74 0c3.52 0 6.373 2.826 6.373 6.313a6.274 6.274 0 0 1-2.221 4.79A22.354 22.354 0 0 1 0 1.2 6.385 6.385 0 0 1 3.74 0",
    fill: "#FAD755",
    mask: "url(#bonus-coins_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.373 1.965c2.425 0 4.39 1.947 4.39 4.348s-1.965 4.348-4.39 4.348c-2.424 0-4.389-1.947-4.389-4.348s1.965-4.348 4.39-4.348",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.373 10.66c-2.424 0-4.389-1.946-4.389-4.347 0-1.357.628-2.568 1.61-3.366A4.314 4.314 0 0 0 2.293 6.04c0 2.4 1.965 4.347 4.39 4.347a4.397 4.397 0 0 0 2.777-.981 4.396 4.396 0 0 1-3.086 1.256",
    fill: "#FFFF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.373 1.965c2.425 0 4.39 1.947 4.39 4.348 0 1.55-.819 2.91-2.05 3.68C12.97 5.824 8.198.01 3.264 3.242a4.396 4.396 0 0 1 3.108-1.278",
    fill: "#D2A00A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.373 2.85c1.93 0 3.496 1.55 3.496 3.463 0 1.912-1.565 3.462-3.496 3.462-1.93 0-3.495-1.55-3.495-3.462 0-1.912 1.565-3.462 3.495-3.462",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.373 2.85c1.93 0 3.496 1.55 3.496 3.463a3.455 3.455 0 0 1-1.714 2.979 18.53 18.53 0 0 1-4.24-5.44A3.5 3.5 0 0 1 6.374 2.85",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.622 7.594a3.454 3.454 0 0 1-.56.931A18.536 18.536 0 0 1 4.89 3.179a3.493 3.493 0 0 1 .987-.293 18.538 18.538 0 0 0 3.745 4.709",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.652 9.703a1.715 1.715 0 0 1-1.723-1.706c0 .942-.771 1.706-1.723 1.706.952 0 1.723.764 1.723 1.707 0-.943.771-1.707 1.723-1.707",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bonus-coins_svg__k)",
    transform: "translate(2.764 9.955)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coins_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coins_svg__l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.118 20.045c5.573 0 10.118-4.502 10.118-10.023S15.691 0 10.118 0 0 4.502 0 10.022s4.545 10.023 10.118 10.023",
    fill: "#F5BE14",
    mask: "url(#bonus-coins_svg__m)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coins_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coins_svg__n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.936 0c5.589 0 10.118 4.487 10.118 10.022a9.959 9.959 0 0 1-3.526 7.603C6.96 13.72 2.572 8.27 0 1.906A10.135 10.135 0 0 1 5.936 0",
    fill: "#FAD755",
    mask: "url(#bonus-coins_svg__o)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.118 3.12c3.848 0 6.968 3.09 6.968 6.902 0 3.812-3.12 6.903-6.968 6.903s-6.968-3.09-6.968-6.902c0-3.813 3.12-6.903 6.968-6.903",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.118 16.924c-3.848 0-6.968-3.09-6.968-6.902 0-2.154.996-4.077 2.557-5.343a6.849 6.849 0 0 0-2.069 4.908c0 3.812 3.12 6.902 6.969 6.902a6.98 6.98 0 0 0 4.41-1.559 6.98 6.98 0 0 1-4.899 1.994",
    fill: "#FFFF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.118 3.12c3.848 0 6.968 3.09 6.968 6.902 0 2.46-1.3 4.62-3.255 5.841C20.59 9.248 13.016.017 5.184 5.15a6.98 6.98 0 0 1 4.934-2.029",
    fill: "#D2A00A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.118 4.526c3.064 0 5.549 2.46 5.549 5.496 0 3.036-2.485 5.497-5.549 5.497-3.065 0-5.55-2.461-5.55-5.497 0-3.035 2.485-5.496 5.55-5.496",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.118 4.526c3.064 0 5.549 2.46 5.549 5.496a5.484 5.484 0 0 1-2.72 4.73 29.418 29.418 0 0 1-6.73-8.637 5.558 5.558 0 0 1 3.901-1.59",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.275 12.055a5.484 5.484 0 0 1-.89 1.48 29.418 29.418 0 0 1-6.623-8.49A5.544 5.544 0 0 1 9.33 4.58a29.43 29.43 0 0 0 5.945 7.474",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.973 15.404c-1.51 0-2.735-1.213-2.735-2.709 0 1.496-1.225 2.71-2.736 2.71 1.511 0 2.736 1.212 2.736 2.708 0-1.496 1.224-2.709 2.735-2.709",
    fill: "#FFF"
  })))));
};
export default SvgBonusCoins;